/**
 * sol-nav · 产研工作台页签导航数据（单一来源）
 * ------------------------------------------------------------
 * 供两处共用，避免分组/页签/路由两处漂移：
 * - EMA-web/src/shell/RailNav.vue：/product 时系统左栏直接渲染产研导航（UNavTree）
 * - modules/solution/web/SolWorkbench.vue：依据路由渲染对应内容视图
 */

export type SolTab =
  | 'overview' | 'goal' | 'plan'
  | 'reqlist' | 'reqreview' | 'reqdetail' | 'reqview'
  | 'feats' | 'tests' | 'devplan' | 'solution'

export interface SolNavItem { id: string; name: string; sub: string }
export interface SolNavGroup { id: string; name: string; ic: string; color: string; items: SolNavItem[] }

/* 分组功能树：产研总览（总览/项目目标/项目计划） / 需求管理（需求/功能/用例/开发方案）/ 解决方案 */
export const SOL_GROUPS: SolNavGroup[] = [
  {
    id: 'ov', name: '产研总览', ic: '总', color: '#4c7df0',
    items: [
      { id: 'overview', name: '总览', sub: '需求漏斗 · Agent 执行 · 方案沉淀' },
      { id: 'goal', name: '项目目标', sub: '业务域目标 · 关键结果进度' },
      { id: 'plan', name: '项目计划', sub: '阶段计划 · 业务域排期' },
    ]
  },
  {
    id: 'req', name: '需求管理', ic: '需', color: '#2e8b8b',
    items: [
      { id: 'reqlist', name: '需求清单', sub: '字段检索 · 结果列表 · 详情独立页签' },
      { id: 'reqdetail', name: '需求详情', sub: '正文空间 · A/B 布局 · 沉浸阅读' },
      { id: 'feats', name: '功能清单', sub: '看板 · 列表 · 状态由交付机制驱动' },
      { id: 'tests', name: '测试用例', sub: '用例执行 · 全部通过后可上线' },
      { id: 'devplan', name: '开发方案', sub: '技术方案 · 流水线触发' },
    ]
  },
  {
    id: 'sol', name: '解决方案', ic: '方', color: '#7c5cff',
    items: [
      { id: 'solution', name: '解决方案', sub: '方案库 · 方案详情 · 方案知识' },
    ]
  },
]

/* 页签 ↔ 路由一一对应 */
export const SOL_PATH: Record<SolTab, string> = {
  overview: '/product/overview',
  goal: '/product/goals',
  plan: '/product/plan',
  reqlist: '/product/requirements',
  /* reqreview 菜单入口已下线，PATH 仅作类型兜底（无导航项触发），全景页只能经 panorama/:id 直达 */
  reqreview: '/product/requirements',
  reqdetail: '/product/requirements/detail',
  reqview: '/product/requirements/detail',
  feats: '/product/features',
  tests: '/product/test-cases',
  devplan: '/product/dev-plan',
  solution: '/product/solutions'
}

/* /product 路由 → 页签（RailNav 高亮与 SolWorkbench 视图切换共用） */
export function solTabFor(p: string): SolTab {
  if (p.startsWith('/product/requirements/panorama/')) return 'reqreview'
  if (p.startsWith('/product/requirements/detail/')) return 'reqview'
  if (p === '/product/requirements') return 'reqlist'
  if (p === '/product/requirements/detail') return 'reqdetail'
  if (p === '/product/features') return 'feats'
  if (p === '/product/test-cases') return 'tests'
  if (p === '/product/dev-plan') return 'devplan'
  if (p === '/product/overview') return 'overview'
  if (p === '/product/goals') return 'goal'
  if (p === '/product/plan') return 'plan'
  return 'solution'
}

/* /product 路由判定（排除 /product2 的 FDE 页面） */
export function isSolRoute(p: string): boolean {
  return p === '/product' || p.startsWith('/product/')
}
